require('./RACustomTickWithObjective.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const moment = require('moment');

//@utilities
const { formatText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');

//@constants
const {
    DATE_FORMAT_DAY_MONTH,
    DATE_FORMAT_YEAR,
} = require('../../../raConstants/index');
const {
    DATA_DATE_FORMAT,
    TICK_BUTTON_BORDER_COLOR,
    TICK_DISABLED_COLOR,
    TICK_TEXT_COLOR,
} = require('../../../raConstants/RAObjectiveTracking');

class RACustomTickWithObjective extends React.Component {
    render() {
        const {
            payload,
            x,
            y,
            disabled,
            noOfPoints,
            showPointsList,
            hasRoboNotHired,
        } = this.props;
        let content;
        let borderColor =
            disabled || hasRoboNotHired
                ? TICK_DISABLED_COLOR
                : TICK_BUTTON_BORDER_COLOR;
        let textColor =
            disabled || hasRoboNotHired ? TICK_DISABLED_COLOR : TICK_TEXT_COLOR;
        const today = moment().format(DATA_DATE_FORMAT);
        if (disabled && !hasRoboNotHired) {
            content = null;
        } else if (
            payload &&
            payload.index === noOfPoints - 1 &&
            moment(payload.value).format(DATA_DATE_FORMAT) === today
        ) {
            content = (
                <g>
                    <rect
                        x={x - 40}
                        y={y - 5}
                        width="50"
                        height="33"
                        rx="15"
                        ry="15"
                        stroke={borderColor}
                        fill="none"
                    />
                    <text
                        x={x - 15}
                        y={y + 16}
                        fill={textColor}
                        textAnchor="middle"
                        className="ra-custom-tick__today"
                    >
                        {formatText('rentabilityGraph-today')}
                    </text>
                </g>
            );
        } else if (payload && showPointsList.indexOf(payload.index) !== -1) {
            const dateObject = moment(payload.value, DATA_DATE_FORMAT);
            const day = dateObject.format(DATE_FORMAT_DAY_MONTH);
            content = (
                <text
                    x={x - 20}
                    y={y + 10}
                    fill={textColor}
                    textAnchor="left"
                    className="ra-custom-tick__date"
                >
                    <tspan x={x - 20} y={y + 10}>
                        {day && toCamelCase(day).replace('.', '')}
                    </tspan>
                    <tspan x={x - 20} y={y + 24}>
                        {dateObject.format(DATE_FORMAT_YEAR)}
                    </tspan>
                </text>
            );
        } else content = null;
        return content;
    }
}

RACustomTickWithObjective.propTypes = {
    disabled: PropTypes.bool.isRequired,
    handleObjectiveClick: PropTypes.func,
    showPointsList: PropTypes.array.isRequired,
    noOfPoints: PropTypes.number,
    payload: PropTypes.object,
    hasRoboNotHired: PropTypes.bool,
    x: PropTypes.number,
    y: PropTypes.number,
};

module.exports = RACustomTickWithObjective;
